import { Component } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ErrorHandling} from "../../../../common/classes/ErrorHandling";
import {AppNavigator, NavigatorTarget} from "../../../../services/app-navigator";
import {MerchantApi} from "../../../../common/apis/merchant-api";
import {isFormSubmitted} from "../../../../common/utilities/FormsHelper";
import {ValidationError} from "../../../../common/interfaces/ValidationError";
import {ValidationErrorType} from "../../../../common/enums/ValidationErrorType";
import { InputType } from 'src/app/common/components/input/enum/InputType';
import {CustomerApi} from "../../../../common/apis/customer-api";

@Component({
  selector: 'app-customer-forget-password',
  templateUrl: './customer-forget-password.component.html',
  styleUrls: ['./customer-forget-password.component.scss']
})
export class CustomerForgetPasswordComponent {
  public showPasswordFieldText = false;
  public signInForm: FormGroup = new FormGroup({});

  serverError: string | null = null
  isLoading = false;

  errorHandling: ErrorHandling | null = null;

  InputType = InputType
  Validators = Validators

  inputEmail = ''

  emailLabel: string = $localize`:@@emailLabel:Email`;
  resetPassword: string = $localize`:@@resetPassword:Reset password`;
  backToLoginLabel: string = $localize`:@@backToLoginLabel:Back To Login`;

  constructor(private formBuilder: FormBuilder,
              private appNavigator: AppNavigator,
              private customerApi: CustomerApi,
  ) {
  }

  ngOnInit() {
  }


  updateInputFieldById(id: string, value: any) {
    if (id == "email") {
      this.inputEmail = value;
    }
  }

  onResetSubmitted() {
    if (isFormSubmitted(this.signInForm)) {
      let email = this.inputEmail;
      this.isLoading = true;
      this.customerApi.forgetPassword(email).subscribe({
        next: () => {
          this.redirectToConfirmEmail();
          this.isLoading = false;
        },
        error: error => {
          this.isLoading = false;
          this.checkError(error)
        }
      })
    }
  }

  checkError(error: any) {
    let message = error.toString();
    if (Array.isArray(error)) {
      let validationError = error as ValidationError[];
      if (validationError.length > 0) {
        let errorHandling = validationError[0] as ValidationError;
        let errorType = errorHandling.errorType;
        if (errorType === ValidationErrorType.ALREADY_EXISTS) {
          message = $localize`:@@emailAlreadySent:Email Already Sent`;
        } else if (errorType === ValidationErrorType.NOT_FOUND) {
          message = $localize`:@@emailNotRegister:Email Not Registered`;
        }
      }
    }
    this.serverError = message;
  }

  onLoginClicked() {
    this.appNavigator.navigateTo({ target: NavigatorTarget.merchantLogin })
  }


  redirectToConfirmEmail(): void {
    this.appNavigator.navigateTo({ target: NavigatorTarget.merchantEmailConfirmPassword })
  }

}
